// Windows (kiosk's local clock, weekdays only) during which the kiosk's
// default idle landing page should be the check-in screen instead of Home.
const CHECK_IN_WINDOWS = [
  { startMinutes: 8 * 60 + 15, endMinutes: 10 * 60 + 35 }, // 8:15 AM - 10:35 AM
  // { startMinutes: 12 * 60 + 30, endMinutes: 14 * 60 + 35 }, // 12:45 PM - 2:35 PM
  { startMinutes: 12 * 60 + 45, endMinutes: 14 * 60 + 35 }, // 12:45 PM - 2:35 PM
];

export function isCheckInWindow(date = new Date()) {
  const day = date.getDay(); // 0 = Sunday, 6 = Saturday
  if (day === 0 || day === 6) {
    return false;
  }

  const minutesNow = date.getHours() * 60 + date.getMinutes();

  return CHECK_IN_WINDOWS.some(
    window => minutesNow >= window.startMinutes && minutesNow <= window.endMinutes
  );
}

// Shared so the check-in page's default bubble text, its post-reset text,
// and its face-detection greeting speech all say exactly the same thing.
export const CHECK_IN_SEARCH_PROMPT =
  "Scroll through the list or enter your name to search for your hearing.";
